import React from 'react'
import { H } from 'react-accessible-headings'
import './error.scss'

interface Props {
    errorCode?: string
    errorDescription?: string
}

const Error: React.FC<Props> = ({ errorCode, errorDescription }) => {
    return (
        <div className="sa-error">
            <div className="sa-error-main">
                <H>Oops!</H>
                <p>Unfortunately, there has been an error.</p>
                {errorDescription ? (
                    <p>{errorDescription}</p>
                ) : (
                    <>
                        {errorCode && <p>Error code: {errorCode}</p>}
                        <p>
                            Please reload the app. If the problem persists contact the SmartAgent
                            team.
                        </p>
                    </>
                )}
            </div>
        </div>
    )
}

export default Error
